import React, { FC } from 'react';

import i18n from '@yandex-int/i18n';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { AliceAppTestChat } from 'client/blocks-redesign/AliceAppTestPage/AliceAppTestChat';
import { PageLayout } from 'client/blocks-redesign/Layout/PageLayout';
import { LinkMobile } from 'client/blocks-redesign/MenuMobile/LinkMobile';
import { routes } from 'client/lib/routes';
import { AliceSkill } from 'client/model/skill';
import { getSettingsEntity } from 'client/utils';
import * as keyset from 'i18n/TestPage';

import styles from './AliceAppTestPage.module.scss';

const t = i18n(keyset);

interface Props {
    isDraft: boolean;
    skill: AliceSkill;
}

export const AliceAppTestPage: FC<Props> = ({ skill, isDraft }) => {
    const testEntity = getSettingsEntity(skill, isDraft);

    return (
        <ErrorBoundary withHomepageLink>
            <PageLayout
                aliceApp={skill}
                pageTitle={`${t('header-test-page')} ${isDraft ? t('menu-draft') : t('menu-published')}`}
            >
                {testEntity.backendSettings.uri || testEntity.backendSettings.functionId ? (
                    <>
                        <div className={styles.testPage__infoBlock}>{t('alert-check-functional')}</div>
                        <div>
                            <AliceAppTestChat
                                skillId={skill.id}
                                isDraft={isDraft}
                                key={isDraft ? 'DRAFT_CHAT' : 'CHAT'}
                            />
                        </div>
                    </>
                ) : (
                    <div>{t('error-need-valid-webhook')}</div>
                )}
            </PageLayout>
            <LinkMobile
                to={routes.app.skillPage(!isDraft, 'test', skill.id)}
                text={`${t('header-test-page')} ${isDraft ? t('menu-published') : t('menu-draft')}`}
                isCurrent
            />
        </ErrorBoundary>
    );
};
